import React from 'react'
import { App } from './views'
import { routesConfig } from './routesConfig'
import { AppIcon } from './components'
import { displayName, appName } from './appConfig'

export const appDefinition = {
  displayName,
  name:      appName,
  category:  'processes',
  Component: () => <App appName={appName} />,
  AppIcon,
  routes:    routesConfig(appName, displayName),
}
